/**
 * OfferContextBar — persistent, non-scrolling bar shown on `/media-units` and
 * `/map` while the screen is in offer-context mode (`addToOfferId` resolved).
 *
 * Purely presentational: the caller supplies fully-translated strings and
 * navigation callbacks so both routes can wire their own `t()` namespace and
 * router instance without duplicating this markup.
 */
import { X } from 'lucide-react';
import { Button } from '@ooh/ui/components/button';

export interface OfferContextBarProps {
  /** Fully-formatted "Dodajesz do oferty: <name>" message. */
  message: string;
  returnLabel: string;
  exitAriaLabel: string;
  onReturnToOffer: () => void;
  onExit: () => void;
}

export function OfferContextBar({
  message,
  returnLabel,
  exitAriaLabel,
  onReturnToOffer,
  onExit,
}: OfferContextBarProps) {
  return (
    <div
      className="shrink-0 flex items-center justify-between gap-3 border-b border-border bg-primary/5 px-4 py-2"
      data-testid="offer-context-bar"
    >
      <span className="text-sm font-medium text-foreground">{message}</span>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          type="button"
          variant="outline"
          size="xs"
          onClick={onReturnToOffer}
          data-testid="offer-context-bar-return"
        >
          {returnLabel}
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={onExit}
          aria-label={exitAriaLabel}
          data-testid="offer-context-bar-exit"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
